import { ValidationErrorResponseSchema } from '@mntn/api-contracts/_shared/error-responses'
import { ErrorResponseSchema } from '@mntn/result'
import { initContract } from '@ts-rest/core'
import {
  DeleteVideoAttachmentBodySchema,
  DeleteVideoAttachmentRequestSchema,
  DeleteVideoAttachmentResponseSchema,
  PostVideoAttachmentBodySchema,
  PostVideoAttachmentRequestSchema,
  PostVideoAttachmentResponseSchema,
} from './schemas.ts'

const c = initContract()

const BASE = '/seller/v1/video-attachments'

export const videoAttachmentsContract = c.router(
  {
    create: c.mutation({
      method: 'POST',
      path: BASE,
      description: 'Insert video attachments so that we can associate to a program',
      body: PostVideoAttachmentBodySchema,
      request: PostVideoAttachmentRequestSchema,
      responses: {
        200: PostVideoAttachmentResponseSchema,
      },
    }),
    delete: c.mutation({
      method: 'DELETE',
      path: BASE,
      description: 'Delete video attachment references',
      body: DeleteVideoAttachmentBodySchema,
      request: DeleteVideoAttachmentRequestSchema,
      responses: {
        200: DeleteVideoAttachmentResponseSchema,
      },
    }),
  },
  {
    strictStatusCodes: true,
    commonResponses: {
      400: ValidationErrorResponseSchema,
      403: ErrorResponseSchema,
    },
    metadata: { tags: ['Video Attachments'] },
  },
)

export type VideoAttachmentsContract = typeof videoAttachmentsContract
